import './About.css'

const About = () =>(
    <div className='about center'>
        <h1>
          Hi, I am <span className='about__name'>Trash Panda.</span>
        </h1>

        <h2 className='about__role'>A UI/UX Student</h2>
      <p className='about__desc'>Currently exploring design techniques to improve various user experiences.</p>
    </div>
)
export default About